import { FC } from 'react';

import { ActivityOverviewIcon, ExportIcon, PlusIcon } from '../../assets/icons/index';
import { PlusIconVariant } from '../../assets/icons/plus-icon';
import { AppFormattedMessage } from '../../components/app-formatted-message/index';
import Button from '../../components/button/index';
import { AnalyticHooks, EventHooks, useSelectedCompany } from '../../hooks/index';
import { PossibleAction } from '../../types/google-analytics-types.types';
import { AccessRole } from '../../types/stakeholder.types';

type ActivityOverviewProps = {
  companyId: string;
  onAddEvent?: () => void;
};

export const ActivityOverview: FC<ActivityOverviewProps> = ({ onAddEvent, companyId }) => {
  const downloadEventsFileTracker = AnalyticHooks.useClick(PossibleAction.DOWNLOAD_FILE);
  const { mutateExport, isPending } = EventHooks.useExport({ companyId });
  const { selectedCompany } = useSelectedCompany();
  const canManageEvents =
    selectedCompany != null && selectedCompany.stakeholder?.accessRole !== AccessRole.AUDITOR;

  return (
    <div className="flex w-full items-center justify-between pb-4 max-lg:border-b max-lg:border-gray-100 lg:rounded-md lg:p-4 lg:shadow-sm">
      <div className="flex items-center gap-2">
        <ActivityOverviewIcon />
        <span className="text-base font-semibold text-gray-700">
          <AppFormattedMessage id="ACTIVITY_OVERVIEW" />
        </span>
      </div>
      <div className="flex h-9 gap-3 max-lg:hidden">
        <Button
          className="flex h-full w-fit gap-1 rounded border border-gray-100 bg-gray-25 px-3 py-[6px]"
          isLoading={isPending}
          onClick={() =>
            mutateExport(undefined, {
              onSuccess: () => {
                downloadEventsFileTracker('Events');
              },
            })
          }
          styleType="NONE"
        >
          <ExportIcon className="rotate-180" />
          <span className="text-sm font-[450] text-gray-700">
            <AppFormattedMessage id="EXPORT" />
          </span>
        </Button>
        {canManageEvents && onAddEvent && (
          <Button
            className="flex h-full w-fit gap-1 rounded bg-brand-700 px-4 py-[6px]"
            data-permission-required
            onClick={onAddEvent}
          >
            <PlusIcon variant={PlusIconVariant.EVENTS} />
            <AppFormattedMessage id="ADD_EVENT" />
          </Button>
        )}
      </div>
    </div>
  );
};
